import { APP, WS_DATA } from './app.constants';

export const CONTACTS = `${APP}_contacts`;

export const WS_DATA_CONTACT = `${WS_DATA}/contact`;
export const WS_DATA_CONTACTS = `${WS_DATA}/contacts`;
export const WS_DATA_ATTENDANCE_MINIMUMS = `${WS_DATA}/attendanceMinimums`;

export const CONTACTS_CHANGED = `${CONTACTS}/CONTACTS_CHANGED`;